<template>
  <div class="own-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Ownership Selection Section -->
    <section class="ownership-selection">
      <div class="container">
        <div class="ownership-content">
          <PageTitle title="Do you own this vehicle?" />
          
          <div class="ownership-options">
            <button 
              :class="['ownership-button', { 'selected': selectedOption === 'yes' }]"
              @click="selectOwnership('yes')"
            >
              Yes
            </button>
            <button 
              :class="['ownership-button', { 'selected': selectedOption === 'no' }]"
              @click="selectOwnership('no')"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'OwnPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedOption: null,
      userQuoteData: null
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 加载之前选择的拥有权状态（如果有的话）
          // 检查是否是添加车辆模式
          if (this.userQuoteData.adding_vehicle && this.userQuoteData.temp_vehicle && this.userQuoteData.temp_vehicle.car_own) {
            this.selectedOption = this.userQuoteData.temp_vehicle.car_own === 'OWN' ? 'yes' : 'no'
          } else if (this.userQuoteData.car_own) {
            this.selectedOption = this.userQuoteData.car_own === 'OWN' ? 'yes' : 'no'
          } else if (this.userQuoteData.owned_leased) {
            // 向后兼容：如果还有旧的owned_leased字段
            this.selectedOption = this.userQuoteData.owned_leased === 'OWN' ? 'yes' : 'no'
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectOwnership(option) {
      this.selectedOption = option
      
      const ownershipValue = option === 'yes' ? 'OWN' : 'LEASE'
      
      // 检查是否是添加车辆模式
      if (this.userQuoteData.adding_vehicle && this.userQuoteData.temp_vehicle) {
        // 添加车辆模式：完成临时车辆数据并添加到vehicles数组
        this.userQuoteData.temp_vehicle.car_own = ownershipValue
        
        // 将完整的车辆信息添加到vehicles数组
        this.userQuoteData.vehicles.push({
          car_year: this.userQuoteData.temp_vehicle.car_year,
          car_make: this.userQuoteData.temp_vehicle.car_make,
          car_model: this.userQuoteData.temp_vehicle.car_model,
          car_own: this.userQuoteData.temp_vehicle.car_own
        })
        
        // 清理临时数据和添加车辆标志
        delete this.userQuoteData.temp_vehicle
        this.userQuoteData.adding_vehicle = false
        
        console.log('Added vehicle to vehicles array:', this.userQuoteData.vehicles)
        console.log('Total vehicles:', this.userQuoteData.vehicles.length + 1) // +1 for primary vehicle
        
        // 保存数据后跳转到表单页面继续添加车辆流程
        this.saveUserData()
        // 提交数据并记录页面提交事件
        await submitDataAndLog('own')
        this.$router.push('/form')
      } else {
        // 第一辆车模式：更新主车辆数据，存储在car_own字段
        this.userQuoteData.car_own = ownershipValue
        console.log('Selected ownership for primary vehicle:', option, 'stored in car_own:', ownershipValue)
        
        this.saveUserData()
        // 提交数据并记录页面提交事件
        await submitDataAndLog('own')
        // 跳转到表单页面
        this.$router.push('/form')
      }
    },
    
    goBack() {
      this.$router.push('/model')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.own-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Ownership Selection */
.ownership-selection {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.ownership-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.ownership-options {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
}

.ownership-button {
  padding: 1.5rem 3rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ownership-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.ownership-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .ownership-options {
    gap: 1rem;
    padding: 0 1rem;
  }

  .ownership-button {
    padding: 1.2rem 2.5rem;
    font-size: 1rem;
    min-width: 100px;
    min-height: 60px;
  }

  .ownership-selection {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {
  .ownership-options {
    gap: 0.8rem;
    flex-direction: row;
  }

  .ownership-button {
    padding: 1rem 2rem;
    font-size: 0.95rem;
    min-width: 90px;
    min-height: 55px;
    flex: 1;
    max-width: 150px;
  }

  .ownership-selection {
    padding: 1rem 0;
  }
}
</style>
